// import { DownloadProvider } from '../contexts/DownloadContext'; // put it inside App.js in case you want to shar eit between components
import Downloads from '../components/Downloads';
//, { homeBlockHeight }

const DownloadsView = () => {
    return <Downloads />;
};

export default DownloadsView;
